import { __ } from '@wordpress/i18n';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

// Config.
import { FILTER_ACTIVE_SHAPE } from '../../../config/prop-types';

// Images.
import iconClose from '../../images/icon-close.png';

// Styles.
import './grantsActiveFilters.scss';

const GrantsActiveFilters = ({
  activeFilters,
  onFilterDeactivate,
}) => (0 < activeFilters.length ? (
  <div className="grants__active-filters grants-active-filters">
    <div className="grants-active-filters__label">
      {__('Search summary:', 'knight-foundation-app')}
    </div>
    <ul className="grants-active-filters__list">
      {activeFilters.map(({ type, value }) => (
        <li key={`${type}-${value}`}>
          <button
            className="grants-active-filters__filter"
            onClick={() => onFilterDeactivate(type, value)}
          >
            <span>
              {value}
            </span>
            <span
              className={classnames(
                'grants__icon',
                'grants-active-filters__icon',
              )}
            >
              <img
                alt={__('Remove filter', 'knight-foundation-app')}
                src={iconClose}
              />
            </span>
          </button>
        </li>
      ))}
    </ul>
  </div>
) : null);

GrantsActiveFilters.propTypes = {
  activeFilters: PropTypes.arrayOf(PropTypes.shape(FILTER_ACTIVE_SHAPE))
    .isRequired,
  onFilterDeactivate: PropTypes.func.isRequired,
};

export default GrantsActiveFilters;
